(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dela-location-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-dela-location]');
  if (!root) return;
  const trigger = root.querySelector('[data-location-open]');
  const dialog = root.querySelector('[data-location-dialog]');
  const close = root.querySelector('[data-location-close]');
  const form = root.querySelector('[data-location-form]');
  const input = root.querySelector('[data-global-postcode]');
  const empty = root.querySelector('[data-location-empty]');
  const savedText = root.querySelector('[data-location-saved]');
  const postcodeText = root.querySelector('[data-location-postcode]');
  const action = root.querySelector('[data-location-action]');
  const error = root.querySelector('[data-location-error]');
  const emptyActionLabel = action.textContent;
  const cartAttributeState = window.delaCartAttributeState || (window.delaCartAttributeState = {});
  const clean = (value) => String(value || '').replace(/\D/g, '').slice(0,5);
  const store = {
    get(key){ try{return localStorage.getItem(key)||'';}catch(e){return '';} },
    set(key,value){ try{localStorage.setItem(key,value);}catch(e){} }
  };
  const setCartAttribute = async (key, value) => {
    const normalizedValue = String(value ?? '');
    if (cartAttributeState[key] === normalizedValue) return;
    cartAttributeState[key] = normalizedValue;
    try {
      const response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({attributes:{[key]:normalizedValue}})
      });
      if (!response.ok) throw new Error('cart_attribute_update_failed');
    } catch(e) {
      if (cartAttributeState[key] === normalizedValue) delete cartAttributeState[key];
    }
  };
  window.delaSetCartAttribute = setCartAttribute;
  const render = (postcode) => {
    const has = postcode.length === 5;
    empty.hidden = has;
    savedText.hidden = !has;
    postcodeText.textContent = postcode;
    action.textContent = has ? 'Cambiar' : emptyActionLabel;
    root.classList.toggle('has-postcode', has);
  };
  const openDialog = () => {
    input.value = clean(store.get('dela_postcode'));
    error.hidden = true;
    trigger.setAttribute('aria-expanded','true');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open','');
    setTimeout(()=>input.focus(),30);
  };
  const closeDialog = () => {
    if (typeof dialog.close === 'function') dialog.close();
    else {
      dialog.removeAttribute('open');
      trigger.setAttribute('aria-expanded','false');
      trigger.focus();
    }
  };
  trigger.addEventListener('click', openDialog);
  close.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
  dialog.addEventListener('close', () => {
    trigger.setAttribute('aria-expanded','false');
    trigger.focus();
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const postcode = clean(input.value);
    input.value = postcode;
    if (postcode.length !== 5) {
      error.hidden = false;
      input.setAttribute('aria-invalid','true');
      return;
    }
    input.removeAttribute('aria-invalid');
    error.hidden = true;
    store.set('dela_postcode', postcode);
    render(postcode);
    await setCartAttribute('Código postal de entrega', postcode);
    document.dispatchEvent(new CustomEvent('dela:location-changed',{detail:{postcode}}));
    closeDialog();
  });
  const initial = clean(store.get('dela_postcode'));
  render(initial);
  if (initial.length === 5) setCartAttribute('Código postal de entrega', initial);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dela-pdp-context"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('[data-dela-context]');
  if (!sections.length) return;

  const cleanPostcode = (value) => String(value || '').replace(/\D/g, '').slice(0, 5);
  const tokens = (value) => String(value || '').split(/[\s,;]+/).map((item) => item.trim()).filter(Boolean);

  const state = window.delaContextState || (window.delaContextState = {});
  const putProperty = (form, name, value) => {
    let input = form.querySelector('input[data-dela-property="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.dataset.delaProperty = name;
      form.appendChild(input);
    }
    input.value = value || '';
  };
  const setPropertyOnForms = (name, value) => {
    state[name] = value || '';
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => putProperty(form, name, state[name]));
  };
  const safeStore = {
    get(key) {
      try { return window.localStorage.getItem(key); } catch (error) { return ''; }
    },
    set(key, value) {
      try { window.localStorage.setItem(key, value); } catch (error) {}
    }
  };

  if (!window.delaContextSubmitSync) {
    window.delaContextSubmitSync = true;
    document.addEventListener('submit', (event) => {
      const productForm = event.target.closest && event.target.closest('form[action*="/cart/add"]');
      if (!productForm) return;
      Object.keys(window.delaContextState || {}).forEach((name) => {
        putProperty(productForm, name, window.delaContextState[name]);
      });
    }, true);
  }

  const publish = (name, detail) => {
    document.dispatchEvent(new CustomEvent(name, { detail }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name.replace(':', '_') }, detail));
    }
  };

  sections.forEach((section) => {
    const form = section.querySelector('[data-postcode-form]');
    const input = section.querySelector('[data-postcode-input]');
    const result = section.querySelector('[data-result]');
    const title = section.querySelector('[data-result-title]');
    const text = section.querySelector('[data-result-text]');
    const dot = section.querySelector('[data-status-dot]');
    const facts = section.querySelector('[data-result-facts]');
    const promiseFact = section.querySelector('[data-fact-promise]');
    const feeFact = section.querySelector('[data-fact-fee]');
    const codFact = section.querySelector('[data-fact-cod]');
    const promise = section.querySelector('[data-promise]');
    const fee = section.querySelector('[data-fee]');
    const cod = section.querySelector('[data-cod]');
    const dateWrap = section.querySelector('[data-date-wrap]');
    const dateInput = section.querySelector('[data-date-input]');
    const recovery = section.querySelector('[data-recovery]');
    const giftCheckbox = section.querySelector('[data-gift-checkbox]');
    const giftMessage = section.querySelector('[data-gift-message]');
    const changeButton = section.querySelector('[data-postcode-change]');
    const checkerMode = section.dataset.checkerMode || 'contact';
    const deliveryMode = section.dataset.deliveryMode || 'standard';
    const productCod = section.dataset.productCod === 'true';
    const zones = Array.from(section.querySelectorAll('[data-zone]'));

    if (!form || !input || !result) return;

    if (dateInput) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      dateInput.min = yyyy + '-' + mm + '-' + dd;
      dateInput.addEventListener('change', () => {
        setPropertyOnForms('Fecha solicitada', dateInput.value);
        publish('dela:date-select', { date: dateInput.value });
      });
    }

    if (giftCheckbox && giftMessage) {
      giftCheckbox.addEventListener('change', () => {
        giftMessage.disabled = !giftCheckbox.checked;
        setPropertyOnForms('Es regalo', giftCheckbox.checked ? 'Sí' : '');
        if (!giftCheckbox.checked) {
          giftMessage.value = '';
          setPropertyOnForms('Mensaje de regalo', '');
        }
        publish('dela:gift-toggle', { enabled: giftCheckbox.checked });
      });
      giftMessage.addEventListener('input', () => {
        setPropertyOnForms('Mensaje de regalo', giftMessage.value.trim());
      });
    }

    const resetFacts = () => {
      [promiseFact, feeFact, codFact].forEach((el) => { if (el) el.hidden = true; });
      if (facts) facts.hidden = true;
      if (recovery) recovery.hidden = true;
      if (dateWrap) dateWrap.hidden = true;
      dot.className = 'dela-context__status-dot';
    };

    const matchZone = (postcode) => zones.find((zone) => {
      return tokens(zone.dataset.postcodes).some((rule) => {
        if (rule.endsWith('*')) return postcode.startsWith(rule.slice(0, -1));
        return postcode === cleanPostcode(rule);
      });
    });

    const revealDate = () => {
      if (dateWrap && deliveryMode === 'scheduled') dateWrap.hidden = false;
    };

    const evaluate = (postcode, shouldFocus) => {
      resetFacts();
      result.hidden = false;
      safeStore.set('dela_postcode', postcode);
      section.classList.add('has-postcode');
      if (changeButton) changeButton.hidden = false;
      if (window.delaSetCartAttribute) {
        window.delaSetCartAttribute('Código postal de entrega', postcode);
      } else {
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({attributes:{'Código postal de entrega':postcode}})
        }).catch(()=>{});
      }

      if (checkerMode !== 'rules') {
        dot.classList.add('is-warning');
        title.textContent = section.dataset.msgSaved || '';
        text.textContent = section.dataset.msgContact || '';
        revealDate();
        publish('dela:delivery-check', { postcode: postcode, outcome: 'confirm' });
        if (shouldFocus) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      const zone = matchZone(postcode);
      if (!zone) {
        dot.classList.add('is-error');
        title.textContent = section.dataset.msgOutside || '';
        text.textContent = '';
        if (recovery) recovery.hidden = false;
        publish('dela:delivery-check', { postcode: postcode, outcome: 'outside' });
        if (shouldFocus) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      dot.classList.add('is-success');
      title.textContent = zone.dataset.zoneName || postcode;
      text.textContent = section.dataset.msgSaved || '';

      let hasFacts = false;
      if (zone.dataset.promise) {
        promise.textContent = zone.dataset.promise;
        promiseFact.hidden = false;
        hasFacts = true;
      }
      if (zone.dataset.fee) {
        fee.textContent = zone.dataset.fee;
        feeFact.hidden = false;
        hasFacts = true;
      }
      if (codFact) {
        cod.textContent = productCod && zone.dataset.zoneCod === 'true' ? 'Disponible' : 'No disponible';
        codFact.hidden = false;
        hasFacts = true;
      }
      if (facts) facts.hidden = !hasFacts;
      revealDate();
      if (window.delaSetCartAttribute) window.delaSetCartAttribute('Zona DELÁ', zone.dataset.zoneName || '');
      publish('dela:delivery-check', { postcode: postcode, outcome: 'covered', zone: zone.dataset.zoneName || '' });
      if (shouldFocus) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    if (changeButton) {
      changeButton.addEventListener('click', () => {
        section.classList.remove('has-postcode');
        changeButton.hidden = true;
        resetFacts();
        result.hidden = true;
        input.focus();
      });
    }

    document.addEventListener('dela:location-changed', (event) => {
      const postcode = cleanPostcode(event.detail && event.detail.postcode);
      if (postcode.length === 5) {
        input.value = postcode;
        evaluate(postcode, false);
      }
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const postcode = cleanPostcode(input.value);
      input.value = postcode;

      if (postcode.length !== 5) {
        resetFacts();
        result.hidden = false;
        dot.classList.add('is-error');
        title.textContent = section.dataset.msgInvalid || '';
        text.textContent = '';
        input.setAttribute('aria-invalid', 'true');
        publish('dela:delivery-check', { postcode: postcode, outcome: 'invalid' });
        return;
      }

      input.removeAttribute('aria-invalid');
      evaluate(postcode, true);
    });

    const saved = cleanPostcode(safeStore.get('dela_postcode'));
    if (saved.length === 5) {
      input.value = saved;
      evaluate(saved, false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
